export const ActionTypes = {
  LOADING: "LOGOUT_LOADING",
  ERROR: "LOGOUT_ERROR",
  SUCCESS: "LOGOUT_SUCCESS",
};
